/**
 * Formats a field label with a required indicator (*) if the field is required.
 * @param label - The field label text
 * @param required - Whether the field is required
 * @returns The formatted label with * appended if required
 */
export function formatFieldLabel(label: string, required?: boolean) {
  return required ? `${label} *` : label;
}
